/**
 * History direction tracker — psdIndex-based.
 *
 * Stamps each history entry with a monotonically increasing index.
 * Compares current vs target index on popstate to determine
 * forward/backward direction. Appends --reverse suffix to
 * transition name for backward navigation.
 *
 * @see specs/002-swup-view-transitions/contracts/router-api.md
 */

let currentIndex = 0;

/**
 * Initialise the history tracker.
 * Stamps the current (initial) history entry with psdIndex: 0.
 */
export function initHistory() {
    const state = window.history.state || {};
    if (state.psdIndex === undefined) {
        window.history.replaceState({ ...state, psdIndex: 0 }, '');
    } else {
        currentIndex = state.psdIndex;
    }
}

/**
 * Track direction for a Swup visit and update history state.
 *
 * - Popstate (back/forward): reads target psdIndex, compares to current
 * - New navigation: increments currentIndex, stamps new entry
 * - Appends --reverse to animation name for backward navigation
 *
 * @param {Object} visit - Swup visit object
 */
export function trackDirection(visit) {
    const targetIndex = visit.to.state?.psdIndex;

    if (targetIndex !== undefined && targetIndex < currentIndex) {
        // Backward navigation (popstate with lower index)
        visit.direction = 'backward';
        currentIndex = targetIndex;

        if (visit.animation.name && !visit.animation.name.endsWith('--reverse')) {
            visit.animation.name += '--reverse';
        }
    } else {
        // Forward navigation (new link click or popstate with higher/equal index)
        visit.direction = 'forward';
        currentIndex++;

        // Stamp the new history entry with the incremented index
        visit.to.state = visit.to.state || {};
        visit.to.state.psdIndex = currentIndex;
    }
}
